/**
 * career-not-found — the in-shell fallback for unknown URLs. A real surface with
 * a way back, never a silent empty shell.
 */

import {
  KitElement,
  type ActionMap,
  type KitContext,
  type ReadonlySignal,
  type Router,
  type ViewModel,
} from "@platform/web-kit"
import { html, type TemplateResult } from "@platform/web-kit/render"
import { I18nToken, RouterToken } from "../services"
import type { CareerI18n } from "../../i18n"

class NotFoundVm implements ViewModel {
  readonly renderDeps: ReadonlyArray<ReadonlySignal<unknown>> = []
  readonly t: CareerI18n["t"]
  constructor(private readonly router: Router, i18n: CareerI18n) {
    this.t = i18n.t
  }
  go(url: string): void {
    void this.router.navigate(url)
  }
}

export class CareerNotFound extends KitElement<NotFoundVm> {
  protected createViewModel(ctx: KitContext): NotFoundVm {
    return new NotFoundVm(ctx.inject(RouterToken), ctx.inject(I18nToken))
  }

  protected render(vm: NotFoundVm): TemplateResult {
    return html`
      <section class="notfound">
        <h1 class="notfound-title" lang="de">${vm.t("notfound.title")}</h1>
        <p lang="de">${vm.t("notfound.body")}</p>
        <a href="/search" data-act="nav" data-url="/search" lang="de">${vm.t("notfound.back")}</a>
      </section>
    `
  }

  protected override actions(vm: NotFoundVm): ActionMap {
    return {
      nav: ({ url }, event) => {
        event.preventDefault()
        if (url) vm.go(url)
      },
    }
  }
}
